{
    "ReportPortalInfo_UpgradeTo_Enterprise": "Passez à la version Enterprise pour accéder à cette fonctionnalité",
    "ReportPortalInfo_UpgradeTo_Enterprise_MST": "Passez à CXA Advanced (Historic) pour accéder à cette fonctionnalité",
    "ReportPortalInfo_UpgradeTo_Call Centre Supervisor": "Passer au statut de superviseur du centre d'appel pour accéder à cette fonction.",
    "ReportPortalInfo_UpgradeTo_Call Centre Supervisor_MST": "Passer à CXA Advanced pour accéder à cette fonctionnalité",
    "NAME": "ReportPortalInfo"
}